module.exports = __webpack_public_path__ + "static/img/banner_bg.1a4ef8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner_bg.jpg
// module id = /lez
// module chunks = 1